import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IMeetingCostsPayloadState } from '@app-store/slices/meetingStatistics/meetingCosts'

interface TaskAction extends Action {
    payload: IMeetingCostsPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingStatistics.meetingCosts

function* meetingCostsSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/stats/costs`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* meetingCostsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, meetingCostsSagaTask)
}

export default meetingCostsSaga
